import { range } from 'lodash-es';

// TODO: possible to move on formatters lvl
// from [{ prizeTranslationKey: 'qwe.qwe', placeFrom: 1, placeTo: 1 }] to -> { 1: 'qwe.qwe' }
export const getLeaderboardPlaceToPrizeMap = (leaderboardPrizes) => {
  const leaderboardPlaceToPrizeMap = {};

  for (const leaderboardPrize of leaderboardPrizes) {
    for (const leaderBoardPlace of range(
      leaderboardPrize.placeFrom,
      leaderboardPrize.placeTo + 1
    )) {
      leaderboardPlaceToPrizeMap[leaderBoardPlace] =
        leaderboardPrize.prizeTranslationKey || 0;
    }
  }

  return leaderboardPlaceToPrizeMap;
};
